import axios from '@/lib/AxApi';

export default {
  getPartners(params, cb)
  {
    axios.get('/rest/Partners/getPartners',
    {
      params: params
    })
    .then(response => {
      cb(response.data);
    })
    .catch(e => {
      //TODO
    })
  },
  addPartner(params, cb)
  {
    axios.post('/rest/Partners/addPartner', params)
    .then(response => {
      cb(response.data);
    })
    .catch(e => {
      //TODO
    })
  },
  deletePartnership(params, cb)
  {
    axios.post('/rest/Partners/deletePartnership', params)
    .then(response => {
      cb(response.data);
    })
    .catch(e => {
      //TODO
    })
  },
  acceptPartner(params, cb)
  {
    axios.post('/rest/Partners/acceptPartner', params)
    .then(response => {
      cb(response.data);
    })
    .catch(e => {
      //TODO
    })
  },
  declinePartner(params, cb)
  {
    axios.post('/rest/Partners/declinePartner', params)
    .then(response => {
      cb(response.data);
    })
    .catch(e => {
      //TODO
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/partners.js